module.exports = __webpack_public_path__ + "media/images/PoweredByLogo_300x-51c44523eaa4215707ede82eccd543d6.png";